<div class="photo-details-pane" *ngIf="photo">
    <div class="header">
        <div class="columns">
            <div class="left">
                <!-- <button class="btn btn-icon" (click)="expandPhotoView()"><i class="fa fa-arrows-alt fa-2x"
                    aria-hidden="true"></i></button> -->
            </div>
            <div class="right">
                <ng-container >
                    <sp-dropdown hideStyling="true">
                        <sp-dropdown-item text="Download" (click)="onDownloadPhoto()"></sp-dropdown-item>
                        <sp-dropdown-item *spHasRole="['Admin', 'Manager', 'PortfolioAdmin']" text="Delete" (click)="onDeletePhoto()"></sp-dropdown-item>
                    </sp-dropdown>
                </ng-container>
                <button class="btn btn-icon" (click)="onCloseEditPane()">
                    <i class="fa fa-times fa-2x"aria-hidden="true"></i>
                </button>
            </div>
        </div>
    </div>

    <div class="details">

        <div class="image-container" (click)="showPhotoViewer()">
            <div class="image-hover-overlay">
                <span class="icon">
                    <i class="fa fa-search-plus"></i>
                </span>
            </div>
            <img [src]="photo.largeFileUrl || ''" />
        </div>

        <div class="photo-details">

            <div class="info">
                <div class="message-info">
                    <i class="fa fa-info-circle"></i>
                    <div>
                        Photo uploaded on <span class="info">{{photo?.uploadDate | date }}</span> by <span class="info">{{photo?.uploadByFullName}}</span>
                    </div>
                </div>
            </div>

            <div class="info">
                <label>Assigned {{ 'Component' | terminology | async }}</label>

                <div class="component-value-container" (click)="onComponentEdit()" [hidden]="displayComponentTypeahead == true">
                
                    <!-- This eventually could have MULTIPLE component names.  Just use the 1st for now if exists -->
                    <a class="edit-btn" [class.no-component]="photo.propertyComponents?.length === 0">
                        {{photo.propertyComponents?.length > 0 ? photo.propertyComponents[0].name : ('No assigned ' + (('component' | terminology | async) || 'component'))}}
                    </a>
                </div>

                <div class="typeahead-container" *ngIf="displayComponentTypeahead">
                    <div [hidden]="unassignComponent">
                        <sp-typeahead-property-component
                            #assignComponentTypeahead
                            [selectedPropertyId]="propertyId"
                            [selectedFiscalYear]="fiscalYear?.year"
                            (componentSelected)="setSelectedComponent($event)"
                        ></sp-typeahead-property-component>
                    </div>

                    <!-- <div [hidden]="!unassignComponent" class="form-control unassign-component-msg">
                        No component - Photo will be unassigned
                    </div>

                    <div class="margin-top-10" [hidden]="!photo?.propertyComponentName">
                        <input name="unassignComponent" id="unassignComponent" type="checkbox" [checked]="unassignComponent" (click)="toggleUnassign()" />
                        <label for="unassignComponent" class="margin-top-10 margin-bottom-10">Unassign photo from {{ 'component' | terminology | async }}</label>
                    </div> -->

                    <!-- <div class="margin-top-10" [hidden]="!selectedComponent">
                        <input name="setAsPrimaryPhoto" id="setAsPrimaryPhoto" type="checkbox" [checked]="setAsPrimaryPhoto" (click)="toggleSetAsPrimaryPhoto()" />
                        <label for="setAsPrimaryPhoto" class="margin-top-10 margin-bottom-10">Set as component's primary photo</label>
                    </div> -->

                    <div class="floating-buttons-container">
                        <span class="floating-buttons">
                            <button type="button" (mousedown)="saveAssignedComponent()" [disabled]="!unassignComponent && !selectedComponent"><i class="fa fa-check"></i></button>
                            <button type="button" (mousedown)="hideAndClearComponentTypeahead()"><i class="fa fa-times"></i></button>
                        </span>
                    </div>
                </div>

                <div class="text-end padding-top-5" *ngIf="photo?.propertyComponentName && displayComponentTypeahead == false">
                    <a routerLink="/useraccount/components/{{photo?.propertyComponentId}}" (click)="setComponentDetailBackToPhotos()">View {{ 'component' | terminology | async }} details <i class="fa fa-external-link"></i></a>
                </div>
            </div>

            <div class="info">
                <label>Include in Photos report</label>
                <div>
                    <sp-inline-edit-reactive (save)="saveIncludeInPhotosReport($event, photo)"
                        [value]="photo?.includeInPhotosReport + ''"
                        [options]="includeInPhotosReportOptions"
                        label="Include in Photos report"
                        type="dropdown"></sp-inline-edit-reactive>
                </div>
            </div>

            <div class="info">
                <label>Description</label>
                <div>
                    <sp-inline-edit-reactive (save)="saveDescription($event, photo)"
                        [value]="photo?.description" label="Description" type="inline-textarea">
                    </sp-inline-edit-reactive>
                </div>
            </div>

            <ng-container>
                <div class="meta-info">
                    <label><span>Additional Photo Data</span>
                        <span id="additional-photo-data" class="margin-left-10"><i class="fa fa-question-circle"></i></span>
                    </label>
                    <div>
                        <span class="meta-label">Date Taken:</span>
                        <span class="meta-value">{{(photo?.takenDate | date: 'medium') || 'unavailable'}}</span>
                    </div>
                    <div>
                        <span class="meta-label">GPS:</span>
                        <span class="meta-value">{{ photo?.latitude && photo?.longitude ? photo?.latitude + ', ' + photo?.longitude : 'unavailable'}}</span>
                    </div>
                </div>
            </ng-container>

        </div>
    </div>
</div>

<sp-modal title="REMOVE PHOTO" (confirm)="onDeletePhotoConfirm()" confirmButtonText="Remove" isWarning="true" #deletePhotoModal>
    Do you want to remove the selected photo from your photo library?
</sp-modal>

<dx-tooltip target="#additional-photo-data" [wrapperAttr]="{ class: 'additional-photo-data-tooltip' }" showEvent="mouseenter"
    hideEvent="mouseleave" position="top">
    <div *dxTemplate="let data = data; of: 'content'">
        <div>
            Additional photo data is extracted from information embedded within the photo. Not all photos contain
            additional data. In which case the values are unavailable.
        </div>
    </div>
</dx-tooltip>
